import React from 'react';
import { OrbitComponent } from '../../base-components/orbit-component/orbit-component';
import { ArenasHeaderBox } from "./boxes/arenas-header/arenas-header.box";
import { ArenasHeaderButtonComponent } from "./parts/arenas-header-button/arenas-header-button.component";
import { ArenasHeaderButtonsBox } from "./boxes/arenas-header-buttons/arenas-header-buttons.box";
import { observer } from 'mobx-react';

export interface MiniOrbitArenasHeaderComponentProps {
    className?: string;
}

export const MiniOrbitArenasHeaderComponent = observer(
    class MiniOrbitArenasHeaderComponent extends OrbitComponent<MiniOrbitArenasHeaderComponentProps> {

        private _renderButtons() {
            return this.services.miniOrbit.currentMiniOrbitConfig.arenasHeaderButtons.map(
                btnConfig => <ArenasHeaderButtonComponent key={btnConfig.link} config={btnConfig} />
            )
        }

        render() {
            return (
                <ArenasHeaderBox className={'cy-arenas-header'}>
                    <ArenasHeaderButtonsBox>
                        {this._renderButtons()}
                    </ArenasHeaderButtonsBox>
                </ArenasHeaderBox>
            );
        }
    }
);